import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../localization";
import { loadTeam } from "../../redux/actions/team";

class Team extends Component {
    componentDidMount() {
        this.props.loadTeam();
    }

    _renderTeam() {
        const { teamData } = this.props;

        return (
            <div className="flex">
                <div className="xl:w-4/12" />
                <div className="xl:w-8/12">
                    {teamData.map((team) => {
                        return (
                            <div key={team.id} className="">
                                <div
                                    className={
                                        "text-17 xl:text-23 text-pink team-body"
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: team.job,
                                    }}
                                />
                                <p className="ml-16 text-17 xl:text-23 text-white">
                                    {team.name}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        const { teamData, locale } = this.props;

        if (!teamData) return null;

        return (
            <div className="bg-blue pt-60 xl:pt-100 pb-60 xl:pb-100 px-16 xl:px-50">
                <h1 className="font-judge font-bold text-50 xl:text-100 text-pink mb-40 xl:mb-80 text-center">
                    {Localization[locale].info.team_title}
                </h1>
                {this._renderTeam()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    teamData: state.team.data,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadTeam,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Team);
